import axios from "axios";

let request = axios.create({
  baseURL: process.env.VUE_APP_APPVERSION_BASE_URL,
  timeout: 5000,
});
//请求拦截器
request.interceptors.request.use((config) => {
  return config;
});
//响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default request;
